export enum Language {
  ENGLISH = 'en-US',
  FRENCH = 'fr-FR',
  SPANISH = 'es-ES',
  GERMAN = 'de-DE',
}
